import './ReviewTable.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

import LineItemsTableHeader from '../../components/LineItemsTableHeader/LineItemsTableHeader';
import useExpandCollapse from '../../hooks/useExpandCollapse';
import type { TagSheetLineItem } from '../../types';
import ReviewLineItemGroup from './ReviewLineItemGroup/ReviewLineItemGroup';

const [block, element] = bem('review-table');

type ReviewTableProps = {
  reviewLineItems: TagSheetLineItem[];
};

const ReviewTable = ({ reviewLineItems }: ReviewTableProps): React.JSX.Element => {
  const { isExpanded, toggleExpand } = useExpandCollapse();

  return (
    <div className={block()}>
      <table className={element('table')}>
        <LineItemsTableHeader />
        {reviewLineItems.map((reviewLineItem) => (
          <ReviewLineItemGroup
            key={reviewLineItem.id}
            groupId={reviewLineItem.id}
            label={reviewLineItem.name}
            ads={reviewLineItem.tagSheetAds}
            startDate={reviewLineItem.startDate}
            endDate={reviewLineItem.endDate}
            billableEvent={reviewLineItem.billableEvent}
            isExpanded={isExpanded}
            onToggleExpand={toggleExpand}
          />
        ))}
      </table>
    </div>
  );
};

export default ReviewTable;
